<template>
  <IconSvgBase :class="$style.icon" :view-width="32" :view-height="32">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.6062 11.192L14.5609 17.8173L12.3835 15.036C11.9302 14.4547 11.0902 14.3533 10.5115 14.808C9.93155 15.2613 9.82888 16.1 10.2835 16.6787L13.5249 20.8213C13.7782 21.144 14.1649 21.332 14.5755 21.332H14.5849C14.9969 21.3307 15.3862 21.136 15.6355 20.8067L21.7275 12.8067C22.1742 12.22 22.0609 11.3853 21.4742 10.9387C20.8862 10.492 20.0515 10.6067 19.6062 11.192ZM16.0001 26.666C10.1187 26.666 5.33341 21.8807 5.33341 15.9993C5.33341 10.118 10.1187 5.33268 16.0001 5.33268C21.8814 5.33268 26.6667 10.118 26.6667 15.9993C26.6667 21.8807 21.8814 26.666 16.0001 26.666ZM16.0001 2.66602C8.63608 2.66602 2.66675 8.63668 2.66675 15.9993C2.66675 23.362 8.63608 29.3327 16.0001 29.3327C23.3641 29.3327 29.3334 23.362 29.3334 15.9993C29.3334 8.63668 23.3641 2.66602 16.0001 2.66602Z"
      :class="$style.icon__path"
    />
  </IconSvgBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

export default defineComponent({
  name: 'IconCheckCircle',
  components: {
    IconSvgBase,
  },
})
</script>

<style lang="scss" module>
.icon {
  width: 1em;
  height: 1em;

  &__path {
    fill: currentcolor;
  }
}
</style>
